module.exports = __webpack_public_path__ + "static/media/heroimage_igib-000.ce23ec0a.jpg";